import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ErrorBoundaryContent from './content';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.error('Error boundary', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryContent />;
    }
    return this.props.children;
  }
}
export default withRouter(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/errorBoundary/errorBoundary.jsx